import React, { useEffect } from 'react';
import { useLocation } from 'react-router';

import { getCategoryForSticky, STICKY_VRM_EVENTS } from 'Utilities/analytics';

import { useBreakpoint } from '../../../../../components/misc/Breakpoints/Breakpoints';
import VrmChecker from '../../../../../components/vrm/VrmChecker/VrmChecker';

import styles from './VrmCheckerWrapper.scss';

const VrmCheckerWrapper = () => {
  const { pathname } = useLocation();
  const category = getCategoryForSticky(pathname);

  const breakpoints = useBreakpoint();
  const tabletBreakpoint = breakpoints?.minWidth?.breakpointTablet;

  useEffect(() => {
    if (tabletBreakpoint) {
      STICKY_VRM_EVENTS.STICKY_VRM_WIDGET_LOADED({
        category,
        label: 'old',
      });
    }
  }, [tabletBreakpoint, category]);

  return (
    <VrmChecker
      home
      className={styles.vrmChecker}
      hideIntent={true}
      isWidget={tabletBreakpoint}
      large={false}
      snowplowEvents={true}
    />
  );
};

export default VrmCheckerWrapper;
